import React, { useEffect, useRef, memo } from "react";

const TradingViewFinancials = () => {
  const containerRef = useRef(null);
  const scriptRef = useRef(null);

  useEffect(() => {
    const timeoutId = window.setTimeout(() => {
      const container = containerRef.current;
      if (!container || scriptRef.current) return;

      container.innerHTML = '<div class="tradingview-widget-container__widget"></div>';

      const script = document.createElement("script");
      script.src = "https://s3.tradingview.com/external-embedding/embed-widget-financials.js";
      script.type = "text/javascript";
      script.async = true;
      script.innerHTML = `
        {
          "isTransparent": true,
          "largeChartUrl": "",
          "displayMode": "regular",
          "width": "100%",
          "height": "100%",
          "colorTheme": "dark",
          "symbol": "NASDAQ:AAPL",
          "locale": "en"
        }`;

      scriptRef.current = script;
      container.appendChild(script);
    }, 0);

    return () => {
      window.clearTimeout(timeoutId);
      if (scriptRef.current) {
        scriptRef.current.remove();
        scriptRef.current = null;
      }
    };
  }, []);

  return (
    <div className="tradingview-widget-container" data-aos="fade-up" ref={containerRef}>
      <div className="tradingview-widget-container__widget"></div>
      <div className="tradingview-widget-copyright">
        {/* <a href="https://www.tradingview.com/" rel="noopener nofollow" target="_blank">
          <span className="blue-text">Track all markets on TradingView</span>
        </a> */}
      </div>
    </div>
  );
};

export default memo(TradingViewFinancials);
